import { style } from 'styled-system';

const columnCount = style({
  prop: 'columnCount',
  cssProperty: 'columnCount'
});

export default columnCount;
